import { IDropdownStyles } from '@fluentui/react';
import { IH2OTheme, IKeyValuePairEditorStyles } from '@h2oai/ui-kit';

export const dropdownStyles = (theme: IH2OTheme): Partial<IDropdownStyles> => ({
  callout: {
    '.is-checked': {
      background: theme.semanticColors?.buttonPrimaryBackground,
      color: theme.palette?.textOverPrimary,
    },
  },
});

export const membersListStyles = (): Partial<IKeyValuePairEditorStyles> => ({
  keyColumn: {
    width: '30%',
    padding: 8,
    paddingRight: 0,
    display: 'flex',
    flexShrink: 0,
    p: { margin: '8px 0' },
    '> *': { width: '100%' },
  },
  valueColumn: {
    flexGrow: 1,
    padding: 8,
    '.h2o-BasicList-item i.ms-Button-icon': { display: 'none' },
  },
  buttonColumn: {
    width: '16%',
    display: 'flex',
    justifyContent: 'center',
    padding: 8,
    paddingLeft: 0,
    flexShrink: 0,
  },
  body: {
    padding: 0,
  },
});
